import * as React from "react";
import { Toast, ToastBody } from "@fluentui/react-components";

export default function Notification({ msg, subtitle = null }) {
  return (
    <Toast>
      <ToastBody subtitle={subtitle}>{msg}</ToastBody>
    </Toast>
  );
}
